module.exports = __webpack_public_path__ + "img/unrevealed6.ada8f7d2.svg";